import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import Modal from '@material-ui/core/Modal';
import TableRow from '@material-ui/core/TableRow';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import EditIcon from '@material-ui/icons/Edit';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import CancelIcon from '@material-ui/icons/Cancel';
import SaveIcon from '@material-ui/icons/Save';
import Grid from '@material-ui/core/Grid';
import Alert from '@material-ui/lab/Alert';
import Collapse from '@material-ui/core/Collapse';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import CircularProgress from '@material-ui/core/CircularProgress';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Checkbox from '@material-ui/core/Checkbox';
import moment from 'moment';
import 'moment/locale/pt-br';
import { instanceAxios } from '../../InstanceAxios';
import environment from '../../environment';
import { PIX_ENABLED, XMEI_PRIMARY_COLOR } from '../../consts/common';

const formatarDescricaoFormaPagamento = (descricao) =>
  descricao === 'PIX AUTOMÁTICO' ? 'PIX RECORRENTE' : descricao;

const useStyles = (theme) => ({
  root: {
    overflow: 'hidden',
  },
  list: {
    width: '100%',
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  formControl: {
    margin: theme.spacing(3),
  },
  button: {
    margin: theme.spacing(1),
  },
  selectTipo: {
    width: 200,
  },
  paper: {
    position: 'absolute',
    width: 800,
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    top: `50%`,
    left: `50%`,
    transform: `translate(-50%, -50%)`,
    width: '80%',
    height: '80%',
    overflow: 'auto',
  },
  loading: {
    marginLeft: '50%',
  },
});

class FormaPagamentoComponent extends Component {
  constructor() {
    super();
    this.axios = instanceAxios(localStorage.getItem('toobiauth'));
    moment.locale('pt-br');
  }

  state = {
    aba: 1,
    pagamentos: [],
    servicos: [],
    servico: [],
    checked: [],
    pagamento: {},
    columns: [
      { id: 'descricao', label: 'Descrição', minWidth: 140 },
      { id: 'parcelas', label: 'Parcelas', minWidth: 70 },
      { id: 'editar', label: '', minWidth: 140 },
      { id: 'excluir', label: '', minWidth: 140 },
    ],
    openErro: false,
    openWarning: false,
    openWarningValid: false,
    openSucess: false,
    openModal: false,
    ready: false,
  };

  async UNSAFE_componentWillMount() {
    await this.axios.get(`${environment}/formaspagamento`).then((res) => {
      const pagamentos = res.data;
      this.setState({ pagamentos });
      this.setState({ ready: true });
    });

    await this.axios.get(`${environment}/servicos`).then((res) => {
      const servicos = res.data;
      this.setState({ servicos });
      this.setState({ ready: true });
    });
  }

  atualizar = async (event) => {
    this.setState({ pagamentos: [] });
    this.setState({ ready: false });
    await this.axios.get(`${environment}/formaspagamento`).then((res) => {
      const pagamentos = res.data;
      this.setState({ pagamentos });
      this.setState({ ready: true });
    });
  };

  clickAlert = () => {
    this.setState({ openError: false });
    this.setState({ openSucess: false });
    this.setState({ openWarning: false });
    this.setState({ openWarningValid: false });
  };

  handleVincular = async (idFormaPagamento) => {
    const lista = this.state.checked;
    if (lista.includes(idFormaPagamento)) {
      await this.axios
        .post(`${environment}/desvincularpagamento`, {
          id_servico: this.state.servico.id,
          id_formadepagamento: idFormaPagamento,
        })
        .then((data) => {
          lista.splice(lista.indexOf(idFormaPagamento), 1);
        })
        .catch((err) => {
          this.setState({ openErro: true });
        });
    } else {
      await this.axios
        .post(`${environment}/vincularpagamento`, {
          id_servico: this.state.servico.id,
          id_formadepagamento: idFormaPagamento,
        })
        .then((data) => {
          lista.push(idFormaPagamento);
        })
        .catch((err) => {
          this.setState({ openErro: true });
        });
    }
    this.setState({ checked: lista });
  };

  handleClickServico = (servico) => {
    this.setState({ servico });
    const checked = [];
    servico.servico_forma_pagamento.map((sfp) => {
      checked.push(sfp.forma_de_pagamento.id);
    });
    this.setState({ checked });
  };

  handleOpenModal = (pagamento) => {
    console.log(pagamento);
    this.clickAlert();
    this.setState({ pagamento });
    this.setState({ openModal: true });
  };

  handleClose = () => {
    this.clickAlert();
    this.setState({ pagamento: {} });
    this.setState({ openModal: false });
  };

  handleClickSave = () => {
    const obj = this.state.pagamento;

    if (obj.descricao === 'BOLETO') obj.tipo = 0;
    else if (obj.descricao === 'PIX AUTOMÁTICO') obj.tipo = 4;
    else if (obj.parcelas === 1) obj.tipo = 1;
    else obj.tipo = 2;

    if (this.state.pagamento.id) {
      this.handleEditarPlano(obj);
    } else {
      this.handleCriarPlano(obj);
    }
  };

  handleEditarPlano = (pagamento) => {
    if (!pagamento.parcelas || !pagamento.descricao) {
      this.setState({ openWarningValid: true });
      return;
    }

    this.axios
      .put(`${environment}/formaspagamento/${pagamento.id}`, pagamento)
      .then(async (resp) => {
        console.log('!!!');
        this.setState({ openSucess: true });
        this.setState({ openModal: false });
        this.setState({ ready: true });
        await this.atualizar();
      })
      .catch((err) => {
        console.log('***');
        this.setState({ openError: true });
        this.setState({ openModal: false });
        this.setState({ ready: true });
      });
  };

  handleCriarPlano = (pagamento) => {
    console.log(pagamento);
    if (!pagamento.parcelas || !pagamento.descricao) {
      this.setState({ openWarningValid: true });
      return;
    }
    this.axios
      .post(`${environment}/formaspagamento`, pagamento)
      .then(async (resp) => {
        this.setState({ openSucess: true });
        this.setState({ openModal: false });
        this.setState({ ready: true });
        await this.atualizar();
      })
      .catch((err) => {
        this.setState({ openError: true });
        this.setState({ openModal: false });
        this.setState({ ready: true });
      });
  };

  handleExcluir = (idPagamento) => {
    this.setState({ ready: false });
    this.axios
      .delete(`${environment}/formaspagamento/${idPagamento}`)
      .then((resp) => {
        this.setState({ openSucess: true });
        this.setState({ ready: true });
        this.atualizar();
      })
      .catch((err) => {
        this.setState({ openError: true });
        this.setState({ ready: true });
      });
  };

  render() {
    const { classes } = this.props;
    return (
      <div style={{ margin: 20 }}>
        <Collapse in={this.state.openError}>
          <Alert severity="error" onClick={this.clickAlert}>
            Erro realizar ação,tente mais tarde!
          </Alert>
        </Collapse>
        <Collapse in={this.state.openSucess}>
          <Alert severity="success" onClick={this.clickAlert}>
            Ação realizada Com Sucesso!
          </Alert>
        </Collapse>
        <Collapse in={this.state.openWarning}>
          <Alert severity="Warning" onClick={this.clickAlert}>
            Aguarde!
          </Alert>
        </Collapse>
        <Grid item xs={12}>
          <ButtonGroup
            fullWidth
            color="primary"
            aria-label="outlined primary button group"
          >
            <Button
              onClick={() => {
                this.setState({ aba: 1 });
              }}
            >
              Formas De Pagamento
            </Button>
            <Button
              onClick={() => {
                this.setState({ aba: 2 });
              }}
            >
              Serviços
            </Button>
          </ButtonGroup>
        </Grid>
        <Collapse in={this.state.aba === 1}>
          <Grid container style={{ paddingTop: '2%' }}>
            <Grid item xs={12} style={{ paddingBottom: '2%' }}>
              <div align="right">
                <Button
                  style={{
                    backgroundColor: XMEI_PRIMARY_COLOR,
                    color: '#FFF',
                    padding: 10,
                  }}
                  startIcon={<AddCircleIcon />}
                  onClick={() => this.handleOpenModal({})}
                >
                  Novo
                </Button>
              </div>
            </Grid>
          </Grid>
          <Paper className={classes.root}>
            <Collapse in={this.state.ready}>
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    {this.state.columns.map((column) => (
                      <TableCell
                        key={column.id}
                        align={column.align}
                        style={{ minWidth: column.minWidth }}
                      >
                        {column.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {this.state.pagamentos.map((p) => {
                    return (
                      <TableRow key={p.id}>
                        <TableCell component="th" scope="row">
                          {formatarDescricaoFormaPagamento(p.descricao)}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {p.parcelas}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          <Button
                            size="small"
                            variant="contained"
                            onClick={() => this.handleOpenModal(p)}
                            startIcon={<EditIcon />}
                            style={{
                              backgroundColor: XMEI_PRIMARY_COLOR,
                              color: '#FFF',
                            }}
                          >
                            Editar
                          </Button>
                        </TableCell>
                        <TableCell component="th" scope="row">
                          <Button
                            size="small"
                            variant="contained"
                            color="secondary"
                            onClick={() => this.handleExcluir(p.id)}
                            startIcon={<CancelIcon />}
                          >
                            Excluir
                          </Button>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </Collapse>
            <Collapse in={this.state.ready === false}>
              <CircularProgress className={classes.loading} />
            </Collapse>
          </Paper>

          <Modal open={this.state.openModal} onClose={this.handleClose}>
            <Grid container spacing={3} className={classes.paper}>
              <h2 style={{ paddingBottom: '5%' }}>Dados do Plano</h2>
              <Collapse in={this.state.openWarning}>
                <Alert severity="Warning" onClick={this.clickAlert}>
                  Aguarde!
                </Alert>
              </Collapse>
              <Collapse in={this.state.openWarningValid}>
                <Alert severity="Warning" onClick={this.clickAlert}>
                  Preencha todos os Dados Necessários
                </Alert>
              </Collapse>
              <Grid item xs={12}>
                <Grid container spacing={3}>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      id="parcelas"
                      label="parcelas"
                      variant="outlined"
                      value={this.state.pagamento.parcelas}
                      type="number"
                      onChange={(event) => {
                        const novoValor =
                          parseInt(event.target.value) > 0
                            ? parseInt(event.target.value)
                            : 0;
                        const obj = this.state.pagamento;
                        obj.parcelas = novoValor;
                        this.setState({ pagamento: obj });
                      }}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      id="descricao"
                      label="Descrição"
                      variant="outlined"
                      value={this.state.pagamento.descricao}
                      select
                      onChange={(event) => {
                        const obj = this.state.pagamento;
                        obj.descricao = event.target.value;
                        this.setState({ pagamento: obj });
                      }}
                    >
                      <MenuItem
                        key="CARTÃO DE CRÉDITO"
                        value="CARTÃO DE CRÉDITO"
                      >
                        Cartão de Crédito
                      </MenuItem>
                      <MenuItem key="BOLETO" value="BOLETO">
                        Boleto
                      </MenuItem>
                      {PIX_ENABLED && (
                        <MenuItem key="PIX AUTOMÁTICO" value="PIX AUTOMÁTICO">
                          Pix Recorrente
                        </MenuItem>
                      )}
                    </TextField>
                  </Grid>
                  <Grid container spacing={3} style={{ paddingTop: '5%' }}>
                    <Grid item xs={12}>
                      <div align="right">
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={this.handleClickSave}
                          startIcon={<SaveIcon />}
                        >
                          Salvar
                        </Button>
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Modal>
        </Collapse>

        <Collapse in={this.state.aba === 2}>
          <Grid container spacing={3} style={{ paddingTop: '5%' }}>
            <Grid item xs={6}>
              <h2>Serviços</h2>
              <List className={classes.list}>
                {this.state.servicos.map((s) => (
                  <ListItem button onClick={() => this.handleClickServico(s)}>
                    <ListItemText primary={s.nome} />
                  </ListItem>
                ))}
              </List>
            </Grid>
            <Grid item xs={6}>
              <h2>Formas de Pagamento</h2>
              <FormControl component="fieldset" className={classes.formControl}>
                <FormLabel component="legend">Vincular Pagamento</FormLabel>
                <FormGroup>
                  {this.state.pagamentos.map((p) => (
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.checked.includes(p.id)}
                          onChange={() => this.handleVincular(p.id)}
                        />
                      }
                      label={`${formatarDescricaoFormaPagamento(
                        p.descricao
                      )} - ${p.parcelas} parcelas`}
                    />
                  ))}
                </FormGroup>
                <FormHelperText>
                  Clique em atualizar antes de trocar de Serviço
                </FormHelperText>
              </FormControl>
            </Grid>
          </Grid>
        </Collapse>
      </div>
    );
  }
}

export default withStyles(useStyles)(FormaPagamentoComponent);
